import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Modal, Row, Table, Col} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from 'prop-types';
import {parseDate, isEmpty} from "enqc-utilities/src/utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../utils/Global";

export default class ComponentAndRectifierInformationModal extends BaseComponent{

    constructor(props) {
        super(props);
        let {model} = this.props
        let components = []
        if(!isEmpty(model)){
            components = model.components
        }else{
            model = {}
        }
        this.state = {
            components:components,
            model:model,
            show:false,
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps!=this.props){
            let show = this.props.show?this.props.show:false
            let {model} = this.props
            let components = []
            if(!isEmpty(model)){
                components = model.components
            }else{
                model = {}
            }
            this.setState({show, model, components}, () => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }

    }


    render() {
        let {model, components, show} = this.state
        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="xl" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.ComponentAndRectifierInformation}</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Header className='text-center bg-light'>
                        <Row className="w-100 d-block">
                            <Col md={12}>
                                <span className="text-center d-block">
                                    {label.ThisModelWillRequireYouToProvideComponentCountAndRectifierCount(model.componentSize, model.sizeOfRectifierControllerSerialNumber)}
                                </span>
                            </Col>
                        </Row>
                    </Modal.Header>
                    <Modal.Body>
                        <Table responsive className="table-sm table-flush">
                            <thead className="thead-light">
                            <tr>
                                <th colSpan="5">
                                <span className="text-center d-block fw-bolder">
                                    {label.ComponentInformation}
                                </span>
                                </th>
                            </tr>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">{label.Label}</th>
                                <th scope="col">{label.Description}</th>
                                <th scope="col" className="text-center d-none d-sm-block">{label.Created}</th>
                                <th scope="col" className="text-center">{label.Updated}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {components.map((item, index) => {
                                return (
                                    <tr scope="row" style={{minHeight:82}} className={(model.id===item.id?"bg-light":"")}>
                                        <td>{(index+1)}</td>
                                        <td>
                                            {item.label}
                                        </td>
                                        <td className="align-items-center" style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {item.description}
                                        </td>
                                        <td className="text-center d-none d-sm-block">
                                            {parseDate(item.created, DD_MMMM_YYYY_HH_MM_SS)}
                                        </td>
                                        <td className="text-center">
                                            {parseDate(item.updated, DD_MMMM_YYYY_HH_MM_SS)}
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
ComponentAndRectifierInformationModal.propTypes = {
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    model:PropTypes.object
}
